import React from 'react';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import { IconTabs, UserAccountButton } from 'components/elements/navigation';
import { useDeviceDetect } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function NavBar() {
  const classes = useStyles();
  const { isDesktop } = useDeviceDetect();
  const { data: brandingData } = useSelector((state) => state.branding);

  return (
    <div className={classes.navBar}>
      <div className={classes.logoWrapper}>
        <img className={classes.mobileIcon} src={brandingData.icon} alt="Mobile Logo Icon" />
      </div>
      {isDesktop && (
        <>
          <div className={classes.tabs}>
            <IconTabs />
          </div>
          <UserAccountButton classes={classes.userIcon} />
        </>
      )}
    </div>
  );
}

export default NavBar;
